export default [
  {
    text: 'payment.table.method',
    value: 'method',
    type: 'slot',
  },
  {
    text: 'payment.table.sum',
    value: 'sum',
    type: 'decimal',
  },
  {
    text: 'payment.table.tip',
    value: 'tip',
    type: 'decimal',
  },
  {
    text: 'payment.table.codes',
    value: 'orders',
    type: 'slot',
  },
  {
    text: 'payment.table.status',
    value: 'status',
  },
  {
    text: 'payment.table.hasRefunds',
    value: 'refunds',
  },
  {
    text: 'payment.table.id',
    value: '_id',
  },
  {
    text: 'payment.table.createdAt',
    type: 'date',
    value: 'createdAt',
    format: 'DD.MM.YYYY HH:mm',
  },
  {
    text: 'payment.table.merchantReference',
    value: 'merchantReference',
    type: 'slot',
    virtual: true,
  },
  {
    text: 'payment.table.checkoutId',
    value: 'checkoutId',
    type: 'slot',
    virtual: true,
  },
  {
    text: 'payment.table.subMethod',
    value: 'subMethod',
  },
  {
    text: '',
    value: 'actions',
    type: 'slot',
    virtual: true,
  },
  { text: '', value: 'data-table-expand' },
];
